<div>
  <mat-checkbox
    [(ngModel)]="withExtraBoard"
    (ngModelChange)="withExtraBoardChanged()"
    ><span class="strong"
      >Ik wil extra onder- of bovenborden (bv.: openhuisborden)</span
    ></mat-checkbox
  >
</div>

<ng-container *ngIf="withExtraBoard">
  <mat-card class="top-card mat-elevation-z0">
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        [(ngModel)]="ipBoard.extraBoard"
        (ngModelChange)="save.emit()"
        [compareWith]="compareOrdinalEnum"
      >
        <mat-option
          *ngFor="let option of EXTRA_BOARD_CHOICES_ARRAY"
          [value]="option"
          >{{ option.label }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <textarea-input
      [title]="'Tekst op het bord'"
      [initContent]="ipBoard.extraBoardText"
      [placeholder]="'Noteer hier de gewenste teksten'"
      [sensitive]="true"
      (answer)="extraBoardTextChanged($event)"
    >
    </textarea-input>

    <textarea-input
      [title]="
        'Gewenste kleuren van het bord, zowel van de achtergrond als van de tekst'
      "
      [initContent]="ipBoard.extraBoardColor"
      [placeholder]="'Noteer hier de gewenste kleuren'"
      [sensitive]="true"
      (answer)="extraBoardColorChanged($event)"
    >
    </textarea-input>
  </mat-card>
</ng-container>
